import { createContext, useContext } from 'react';
export const RadioGroupContext = createContext(undefined);
export const useRadioGroupWithOthers = () => {
    const context = useContext(RadioGroupContext);
    if (!context) {
        throw new Error(`useRadioGroup must be used within a Radio.RadioGroup component`);
    }
    return context;
};
